import { labelSizes, widths } from '../commonDisplayOptions';
import { dateFormats } from './displayOptions';
import { fieldNames } from '../fields';

export const dataModel = {
    component: String(),
    id: String(),
    label: String(),
    labelSize: labelSizes,
    reportingLabel: String(),
    placeholder: String(),
    format: dateFormats,
    value: String(),
    helperText: String(),
    required: Boolean(),
    width: widths['100'].value
};

export const defaults = {
    component: fieldNames.date,
    labelSize: labelSizes.sm.value,
    format: dateFormats.slashMonthDayFullYear.value,
    value: null
};
